// Function to animate elements when they enter the viewport from the bottom
function animateOnViewportEntry(selectors, animationOptions = {}) {
  // Default animation settings
  const defaultOptions = {
    type: 'fade', // 'fade', 'slide', or other custom types
    distance: 30, // Distance for the 'slide' effect
    duration: 1, // Duration of the animation
    stagger: 0.2, // Delay between each element's animation
  };

  // Merge default animation settings with user-provided options
  const options = { ...defaultOptions, ...animationOptions };

  selectors.forEach(selector => {
    // Select all elements matching the current selector
    const elements = document.querySelectorAll(selector);

    // Initialize GSAP animation settings based on the animation type
    switch (options.type) {
      case 'slide-fade':
        gsap.set(elements, { y: options.distance, opacity: 1 });
        break;
      case 'slide':
        gsap.set(elements, { y: options.distance });
        break;
      case 'fade':
      default:
        gsap.set(elements, { opacity: 1 });
        break;
    }

    // Create an intersection observer to trigger animations when elements enter the viewport
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          // defaukt = fade
          var animation = { opacity: 1 };

          switch( options.type ) {
            case 'slide' :
              animation = { y: 0 };
              break;
            case 'slide-fade' :
              animation = { y: 0, opacity: 1 };
              break;
          }

          // Animate the element using GSAP
          gsap.to(entry.target, {
            ...animation,
            duration: options.duration,
            ease: 'power1.out',
            clearProps: 'all',
          });

          // Stop observing the element after it has been animated
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 10% 0px', // Adjust root margin to trigger animations when elements are half way into the viewport
      threshold: 0.1,
    });

    // Observe each element for viewport entry
    elements.forEach(element => {
      observer.observe(element);
    });
  });
}
